<template>
    <hr :style="$vuetify.theme.dark? 'border: 1px dotted #424242;border-radius: 3px;' : 'border: 1px dotted #D0D0D0;border-radius: 3px;' " />
</template>
<script>
export default {
    name: 'Hrline',
}
</script>

